import { render, staticRenderFns } from "./AirLeeChooseClinic.vue?vue&type=template&id=4af4711c&scoped=true&"
import script from "./AirLeeChooseClinic.vue?vue&type=script&lang=js&"
export * from "./AirLeeChooseClinic.vue?vue&type=script&lang=js&"
import style0 from "./AirLeeChooseClinic.vue?vue&type=style&index=0&id=4af4711c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4711c",
  null
  
)

export default component.exports